import React from 'react';
import { Moment } from 'moment';
import GridFilter from '../../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../Base/Enums/GridFilterItemType.enum';
import { getMomentDate } from '../../../../../Utils/dates.util';
import { useAppContext } from '../../../../../Services/AppContext';
import useFilters from '../../../../Base/Hooks/useFilters';
import { GRID_FILTER_KEYS } from '../../../../Base/Components/GridFilter/gridFilterKeys';

export interface InvoicingFilterValues {
	from?: string;
	to?: string;
	workplaceId?: string;
	orderMembers?: string[];
	status?: string;
	isAdmin?: boolean;
}

interface Props {
	onFilter: (values: InvoicingFilterValues) => void;
	isSuperAdmin?: boolean;
}

const InvoicingFilter: React.FC<Props> = ({ onFilter, isSuperAdmin }) => {
	const { workplaceId } = useAppContext();
	const { handleDateTimeValue, handleSelectValue, convertToUpperCase } =
		useFilters();

	const onFilterData = (values: any) => {
		const orderMembers: string[] = [];
		if (values?.patient?.value) {
			orderMembers.push(values?.patient?.value);
		}
		if (values?.doctor?.value) {
			orderMembers.push(values?.doctor?.value);
		}
		const filter: InvoicingFilterValues = {
			from: handleDateTimeValue(values?.dateFrom),
			to: handleDateTimeValue(values?.dateTo),
			orderMembers: orderMembers,
			status: convertToUpperCase(
				handleSelectValue(values?.invoiceStatus?.value),
			),
			workplaceId,
			isAdmin: isSuperAdmin,
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.INVOICING_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={200}
				enableAutocomplete
				customLabel='component.invoicing.from'
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_TO}
				width={200}
				enableAutocomplete
				customLabel='component.invoicing.to'
			/>
			<GridFilterItem
				type={GridFilterItemType.INVOICE_STATE}
				width={260}
				enableAutocomplete
				customPlaceholder='base.shared.pick'
				customLabel='component.invoicing.state'
			/>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ORIGINAL_ID}
				width={380}
				enableAutocomplete
				customLabel='component.invoicing.customer'
			/>
			<GridFilterItem
				type={GridFilterItemType.DOCTOR_ID}
				width={380}
				enableAutocomplete
				customLabel='component.invoicing.invoiceCreatedBy'
			/>
		</GridFilter>
	);
};

export default InvoicingFilter;
